// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Loader } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconLoader(props: any) {
    return <IconBase icon={Loader} {...props} />
  }

  export default IconLoader
  